import React from 'react'

import { ButtonList } from "/react4xp/shared/button-list/button-list";

export default (props) => <ButtonList {...props} />